export const titleSuffix = import.meta.env.VITE_TITLESUFFIX;
